import React from 'react';
import PropTypes from 'prop-types';
import { Identifier } from 'web-ui-components/lib/typography/modifiers';

const PaymentReviewRow = ({ label, main, sub, className, subTitle, wrapMain = false }) => (
	<div className={`c-m-payment-review__row ${className}`}>
		<span className="c-m-payment-review__label">{label}</span>
		<div className="c-m-payment-review__value">
			{!!subTitle && <span className="c-m-payment-review__value-sub">{subTitle}</span>}
			{!wrapMain && <span className="c-m-payment-review__value-main">{main}</span>}
			{wrapMain && (
				<Identifier.Breaking>
					<span className="c-m-payment-review__value-main">{main}</span>
				</Identifier.Breaking>
			)}
			{!!sub && <span className="c-m-payment-review__value-sub">{sub}</span>}
		</div>
	</div>
);

PaymentReviewRow.propTypes = {
	label: PropTypes.string.isRequired,
	main: PropTypes.string.isRequired,
	sub: PropTypes.string,
	className: PropTypes.string,
	subTitle: PropTypes.string,
	wrapMain: PropTypes.bool,
};

export default PaymentReviewRow;
